import React from 'react'
import {useState} from 'react';
import {useTranslation} from "react-i18next";

import PrimaryButton from './PrimaryButton'
import './header.css'
import LocaleSwitcher from "../i18n/LocaleSwitcher";
import ThemeToggle from './theme-toggle/theme-toggle';

const Header = ({showCalModal}) => {
    const {t} = useTranslation();
    const [isMobileMenuVisible, setMobileMenuVisible] = useState(false);

    const toggleMobileMenu = () => {
        setMobileMenuVisible(!isMobileMenuVisible);
        // Prevent body scroll when menu is open
        document.body.classList.toggle('stopScroll', !isMobileMenuVisible);
    };

    const closeMobileMenu = () => {
        setMobileMenuVisible(false);
        document.body.classList.remove('stopScroll');
    };

    return (
        <div data-role="Header" className="header-header">
            <nav className="header-nav">
                <div className="header-container1">
                    <a href="/#home-section-home" className="header-logo-navlink">
                        <img alt="Louis Nguyen" src="/logo.png" className="header-logo"/>
                    </a>

                    <div className="header-menu1">
                        <a href="/#home-section-home">
                            {t("header_menu-home")}
                        </a>
                        <a href="/#problems-solutions">
                            {t("header_menu-services")}
                        </a>
                        <a href="/#profile-section">
                            {t("header_menu-about-me")}
                        </a>
                    </div>

                    <div className="header-container2">
                        <div className="header-controls">
                            <ThemeToggle />
                            <div className="locale-switcher">
                                <LocaleSwitcher />
                            </div>
                        </div>
                        <div className="header-container3">
                            <PrimaryButton action={showCalModal} button={t("header_button-book-call")} />
                        </div>
                        <div data-role="BurgerMenu" className="header-burger-menu" onClick={toggleMobileMenu}>
                            <svg viewBox="0 0 1024 1024" className="header-icon1">
                                <path
                                    d="M128 256h768v86h-768v-86zM128 554v-84h768v84h-768zM128 768v-86h768v86h-768z"
                                />
                            </svg>
                        </div>
                    </div>
                </div>
            </nav>

            <div data-role="MobileMenu" className={`header-mobile-menu ${isMobileMenuVisible ? 'active' : ''}`}>
                <div className="mobile-menu-header">
                    <a href="/#home-section-home" className="header-logo-navlink" onClick={closeMobileMenu}>
                        <img alt="Louis Nguyen" src="/logo.png" className="header-logo"/>
                    </a>
                    <div data-role="CloseMobileMenu" className="header-close-menu" onClick={closeMobileMenu}>
                        <svg viewBox="0 0 1024 1024" className="header-close-icon">
                            <path
                                d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"
                            />
                        </svg>
                    </div>
                </div>

                <div className="mobile-menu-content">
                    <div className="mobile-menu-nav">
                        <a href="/#home-section-home" onClick={closeMobileMenu}>
                            {t("header_menu-home")}
                        </a>
                        <a href="/#problems-solutions" onClick={closeMobileMenu}>
                            {t("header_menu-services")}
                        </a>
                        <a href="/#profile-section" onClick={closeMobileMenu}>
                            {t("header_menu-about-me")}
                        </a>
                    </div>

                    <div className="mobile-menu-footer">
                        <div className="mobile-controls">
                            <ThemeToggle />
                            <div className="mobile-locale-switcher">
                                <LocaleSwitcher />
                            </div>
                        </div>
                        <PrimaryButton
                            button={t("header_button-book-call")}
                            action={() => {
                                closeMobileMenu();
                                showCalModal();
                            }}
                            fullWidth
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header